/** The listing fields the sizes column reads; the search result carries more. */
export interface ListingWithVariants {
  vendor: string;
  variants: { variantValue: string | null }[] | null;
}

/**
 * The sizes a STOCKX row stores, as StockX names them ("9, 9.5, 10"), in stored order. Null for
 * any other vendor, for a row with no variants, and for one whose variants name no value, so the
 * column shows a dash. A graded card's one variant is its grade ("PSA 10").
 */
export function stockxListingSizes(listing: ListingWithVariants): string | null {
  if (listing.vendor !== "STOCKX") return null;
  const values = (listing.variants ?? []).flatMap((variant) => {
    const trimmedValue = variant.variantValue?.trim();
    return trimmedValue ? [trimmedValue] : [];
  });
  return values.length > 0 ? values.join(", ") : null;
}
